import React, { FC } from 'react';
import AuthPage from './AuthPage';

const Register: FC = () => <AuthPage initialScreen="register" />;

export default Register;
